import { Button } from "antd";
import { CurrencyFormat, formatDate } from "../../../../components/helpers";

export const convertFailedRedeem = (failedRedeems, handleOpenPreview) => {
  let convertedFailedRedeems = [];

  if (!failedRedeems) return [];

  failedRedeems.forEach((failedRedeem, index) => {
    convertedFailedRedeems.push({
      key: index + 1,
      failedRedeemID: failedRedeem.failed_redeem_id,
      transactionID: failedRedeem.transaction_id,
      gadaiID: failedRedeem.gadai_id,
      transactionCode: failedRedeem.transaction_code,
      dateTime: formatDate(failedRedeem.date_time) || "-",
      pawnNumber: failedRedeem.gadai_proof || "-",
      receiptNumber: failedRedeem.receipt_number || "-",
      customerName: failedRedeem.customer_name || "-",
      category: failedRedeem.product_category || "-",
      description: failedRedeem.item_description || "-",
      location: failedRedeem.item_location || "-",
      destination: failedRedeem.auction_destination || "-",
      keterangan: failedRedeem.description || "-",
      auctionOtherFee: `Rp ${CurrencyFormat(
        failedRedeem.auction_other_fee || 0
      )}`,
      offerLink: failedRedeem.offer_link ? (
        <Button
          onClick={() =>
            window.open(failedRedeem.offer_link, "_blank", "noopener")
          }
          type="link"
          style={{ padding: 0 }}
        >
          {failedRedeem.offer_link}
        </Button>
      ) : (
        "-"
      ),
      soldPrice: `Rp ${CurrencyFormat(failedRedeem.sold_amount) || 0}`,
      document: failedRedeem.delivery_order ? (
        <Button
          onClick={handleOpenPreview(
            `gadai-failed-redeem/${failedRedeem.failed_redeem_id}/delivery-order-picture`
          )}
          type="link"
          style={{ padding: 0 }}
        >
          Lihat File
        </Button>
      ) : (
        "-"
      ),
      status: failedRedeem.status_name || "-",
    });
  });
  return convertedFailedRedeems;
};
